import { NgModule } from '@angular/core';

import { GlobalSearchModule }   from '../global-search/global-search.module';
import { HeaderComponent }      from './header.component';
import { SharedModule }         from '../shared/shared.module';
import { CustomerMessagesModule } from '../messages/customer-messages/customer-messages.module';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  entryComponents: [
    HeaderComponent
  ],
  exports: [
    HeaderComponent
  ],
  imports: [
    GlobalSearchModule,
    SharedModule,
    CustomerMessagesModule
  ]
})
export class HeaderModule {}
